/**
 * Configuração de domínio público da plataforma.
 *
 * MODELO: domínio neutro único (ex.: https://meucardapio.app) com um slug
 * por cliente — https://meucardapio.app/pasteisdacarme
 *
 * COMO TROCAR DE DOMÍNIO (único lugar a editar):
 * 1. Compre/conecte o domínio neutro em Configurações do Projeto > Domínios.
 * 2. Troque PUBLIC_BASE_URL abaixo pelo novo domínio (sem barra no final).
 * 3. Mantenha o domínio antigo em PUBLIC_HOSTS para os QR codes já impressos
 *    continuarem funcionando enquanto o DNS propaga.
 */
export const PUBLIC_BASE_URL = "https://comidaagora.com";

/** Hosts públicos válidos (domínio neutro, domínios próprios e domínios antigos). */
export const PUBLIC_HOSTS: string[] = [
  new URL(PUBLIC_BASE_URL).hostname,
  "www.comidaagora.com",
  "tiapretalanches.lovable.app", // QR codes antigos continuam funcionando
];

/** Hosts internos do Lovable que exigem login e nunca devem entrar em QR codes. */
function isInternalHost(hostname: string): boolean {
  return (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname.endsWith(".lovableproject.com") ||
    hostname.startsWith("id-preview--") ||
    hostname.endsWith(".sandbox.lovable.dev")
  );
}

/**
 * Base pública usada em links/QR codes.
 * Se o app já está sendo servido por um domínio público (neutro ou próprio do
 * cliente), mantém esse domínio; caso contrário usa o domínio neutro oficial.
 */
export function getPublicBaseUrl(): string {
  if (typeof window === "undefined") return PUBLIC_BASE_URL;
  const host = window.location.hostname;
  if (isInternalHost(host)) return PUBLIC_BASE_URL;
  return window.location.origin;
}

/** URL pública do cardápio de um cliente. */
export function getMenuUrl(slug?: string | null): string {
  const base = getPublicBaseUrl();
  return slug ? `${base}/${slug}` : `${base}/`;
}

/** URL pública do cardápio de mesa de um cliente. */
export function getTableMenuUrl(slug: string, mesa: number | string): string {
  return `${getPublicBaseUrl()}/${slug}/mesa/${mesa}`;
}